 

    /**
    * super simple carousel
    * animation between panes happens with css transitions
    */
    function Carousel(element)
    {
        var self = this;
        element = $(element);

		var container = $(">ul", element);
        var panes = $(">ul>li", element);
		var bullets = $("#"+ element.attr("id") +"-bullets");
		
        var pane_width = 0;
        var pane_count = panes.length;

        var current_pane = 0;


        /**
         * initial
         */
        this.init = function() {
            setPaneDimensions();

			initializeBullets();
			
            $(window).on("load resize orientationchange", function() {
                setPaneDimensions();
            })
			
			$("a#prev").click(function(){
				prevPane = current_pane - 1;
				if (prevPane < 0) { prevPane = pane_count; }
                self.showPane(prevPane, true);
			});
			$("a#next").click(function(){
				nextPane = current_pane + 1;
				if (nextPane >= pane_count) { nextPane = 0; }
                self.showPane(nextPane, true);
			});
			$("a.set-carousel-slide").click(function () {
			    var slideIndex = $(this).attr("data-slide-index");
                self.showPane(slideIndex, true);
			});
			
        };

		/**
         * set the pane dimensions and scale the container
         */
        function setPaneDimensions() {
            pane_width = element.width();
            panes.each(function() {
                $(this).width(pane_width);
            });
            container.width(pane_width*pane_count);
        };

		function initializeBullets() {
			var counter = 0;
			panes.each(function() {
				currentOrNot = "";
				if (counter == 0) {
					currentOrNot = "icon-current";
				}
				bullets.append('<i class="bullet-'+ counter +' icon-circle '+ currentOrNot +'"></i>');
				counter += 1;
			});
		}

        /**
         * show pane by index
         */
        this.showPane = function(index, animate) {
            // between the bounds
            index = Math.max(0, Math.min(index, pane_count-1));
            current_pane = index;
            LazyLoadImage(panes[current_pane]);//load image by lazy loading

            var offset = -((100/pane_count)*current_pane);
            setContainerOffset(offset, animate);
			
			// handle bullets
			$("#"+ element.attr("id") +"-bullets i").removeClass("icon-current");
            $("#" + element.attr("id") + "-bullets i.bullet-" + current_pane).addClass("icon-current");
        };


        function setContainerOffset(percent, animate) {
            container.removeClass("animate");

            if(animate) {
                container.addClass("animate");
            }

            if(Modernizr.csstransforms3d) {
                container.css("transform", "translate3d("+ percent +"%,0,0) scale3d(1,1,1)");
            }
            else if(Modernizr.csstransforms) {
                container.css("transform", "translate("+ percent +"%,0)");
            }
            else {
                var px = ((pane_width*pane_count) / 100) * percent;
                container.css("left", px+"px");
            }
        }

        this.next = function() { return this.showPane(current_pane+1, true); };
        this.prev = function() { return this.showPane(current_pane-1, true); };


        function handleHammer(ev) {
            ev.preventDefault();

            switch(ev.type) {
                case 'dragright':
                case 'dragleft':
                    // stick to the finger
                    var pane_offset = -(100/pane_count)*current_pane;
                    var drag_offset = ((100/pane_width)*ev.gesture.deltaX) / pane_count;

                    // slow down at the first and last pane
                    if((current_pane == 0 && ev.gesture.direction == "right") ||
                        (current_pane == pane_count-1 && ev.gesture.direction == "left")) {
                        drag_offset *= .4;
                    }

                    setContainerOffset(drag_offset + pane_offset);
                    break;

                case 'swipeleft':
                    self.next();
                    break;

                case 'swiperight':
                    self.prev();
                    break;

                case 'release':
                    // more then 50% moved, navigate
                    if(Math.abs(ev.gesture.deltaX) > pane_width/2) {
                        if(ev.gesture.direction == 'right') {
                            self.prev();
                        } else {
                            self.next();
                        }
                    }
                    else {
                        self.showPane(current_pane, true);
                    }
                    break;
            }
        }

        new Hammer(element[0], { drag_lock_to_axis: true }).on("release dragleft dragright swipeleft swiperight", handleHammer);
    }

 
    